import React, { PropTypes, Component } from 'react';
import ReactDOM from 'react-dom';
import * as Icons from 'components/Material/SvgIcons';
import classNames from 'classnames';
import { ToolbarButton } from 'components/Toolbar';
import { Units, Colors, Shadow } from 'Css';
import Option from './Option';
import Tooltip from 'components/Tooltip';

const ESC = 27;

const css = oxygenCss({
  root: {
    padding: 0,
    height: 40,
    whiteSpace: 'nowrap',
    position: 'relative',
    overflow: 'hidden',
    minWidth: Units.keyline * 2,
    // backgroundColor: Colors.fullWhite,
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    borderRadius: 2.2,
    border: 'solid 2px #EEE',
    display: 'inline-block',
    cursor: 'pointer',
    '&fullWidth': {
      display: 'block'
    },
    '&dark': {
      border: 'solid 2px #101010',
      backgroundColor: Colors.darkBlack
    }
  },
  inputContainer: {
    marginRight: 40,
    // backgroundColor: 'rgba(255, 255, 255, 0.9)',
    // borderStyle: 'none solid none none',
    // borderWidth: 1,
    // borderColor: Colors.text.Dark.divider,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    width: '100%',
    padding: `0 ${Units.base}px`,
    verticalAlign: 'top',
    lineHeight: `${40}px`,
    height: 40,
    textAlign: 'left',
    boxSizing: 'border-box'
  },
  button: {
    position: 'absolute',
    right: 0,
    top: 0
  }
});

export default class DropDown extends Component {
  static propTypes = {
    dark: PropTypes.bool,
    options: PropTypes.array,
    placeholder: PropTypes.string,
    fullWidth: PropTypes.bool,
    selected: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object
    ]),
    onChange: PropTypes.func
  };

  static defaultProps = {
    placeholder: 'Select',
    fullWidth: false
  };

  state = {
    active: false
  };

  getNode = () => {
    return ReactDOM.findDOMNode(this);
  };

  activate = () => {
    if (!this.state.active) {
      this.setState({ active: true });
    }
  };

  deactivate = () => {
    if (this.state.active) {
      this.setState({ active: false });
    }
  };

  handleKeyDown = event => {
    const { keyCode } = event;
    if (keyCode === ESC && this.state.active) {
      this.deactivate();
    } else if (!this.state.active) {
      this.activate();
    }
  };

  handleSelect = payload => {
    const { selected, onChange } = this.props;
    if (selected !== payload) {
      onChange && onChange(payload);
    }
    this.deactivate();
  };

  positionDropdown = (rect, ownRect) => ({
    left: rect.left,
    top: rect.top,
    width: rect.width
  });

  render() {
    const { fullWidth, dark, options, placeholder, selected } = this.props;
    const { active } = this.state;
    const classes = classNames(css.root, {
      [css.fullWidth]: fullWidth,
      [css.dark]: dark
    });
    const selectedOption =
      options.find(option => option.payload === selected) || {};
    return (
      <div className={classes}>
        <div className={css.inputContainer} onTouchTap={this.activate}>
          {selectedOption.label || placeholder}
        </div>
        <ToolbarButton
          onTouchTap={this.activate}
          className={css.button}
          onKeyDown={this.handleKeyDown}
        >
          <Icons.HardwareKeyboardArrowDown
            color={
              dark ? Colors.text.Light.secondary : Colors.text.Dark.secondary
            }
          />
        </ToolbarButton>
        {active && (
          <Tooltip
            onClickAway={this.deactivate}
            hasArrow={false}
            anchorTo={this.getNode}
            padded={false}
            getPosition={this.positionDropdown}
          >
            {options.map(option => {
              const { payload, label } = option;
              return (
                <Option
                  selected={selectedOption.payload === payload}
                  key={payload}
                  payload={payload}
                  onTouchTap={this.handleSelect}
                >
                  {label}
                </Option>
              );
            })}
          </Tooltip>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/DropDown/DropDown.js